export default "__VITE_ASSET__Cac50xbM__"